import React, { useEffect, useState } from 'react';
import { registroPara } from '../data/escenas';

// «Así se ve», como producto y no como texto (An, 04/11: «podría ser un pdf de un word todavía»): una ventana
// donde se ve el pedido, los pasos que hace y la entrega. El botón Aprobar la pasa al registro de tareas, que
// es la otra pestaña de la misma ventana. Con movimiento reducido se muestra todo de una.
const PASO = 750;

const DemoAgencia = ({ escena }) => {
  const quieto = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const total = escena.acciones.length + 1; // los pasos y después la entrega
  const [visto, setVisto] = useState(quieto ? total : 0);
  const [aprobado, setAprobado] = useState(false);
  const [pestana, setPestana] = useState('charla');

  useEffect(() => {
    if (visto >= total) return undefined;
    const t = setTimeout(() => setVisto(v => v + 1), visto === 0 ? PASO * 1.4 : PASO);
    return () => clearTimeout(t);
  }, [visto, total]);

  // Al aprobar no salta solo al registro: aparece el link para entrar (An, 04/11: «registro debería ser un link,
  // como para que te des cuenta que podés entrar»).
  const aprobar = () => setAprobado(true);
  const repetir = () => { setAprobado(false); setPestana('charla'); setVisto(quieto ? total : 0); };
  const filas = registroPara(escena).map((f, i) => (i === 0 && aprobado ? { ...f, estado: 'Aprobado' } : f));

  return (
    <figure className="gh-demo" aria-label={`Ejemplo: lo que le pedís a ${escena.quien.toLowerCase()} y lo que te entrega`}>
      <div className="gh-demo__barra">
        <span className="gh-demo__nombre">{escena.quien}</span>
        <div className="gh-demo__pestanas" role="tablist">
          <button type="button" role="tab" aria-selected={pestana === 'charla'} onClick={() => setPestana('charla')}>Pedido</button>
          <button type="button" role="tab" aria-selected={pestana === 'registro'} onClick={() => setPestana('registro')}>Registro</button>
        </div>
      </div>
      {pestana === 'charla' ? (
        <div className="gh-demo__cuerpo" role="tabpanel">
          <p className="gh-demo__pedido">{escena.pedido}</p>
          <ol className="gh-demo__pasos">
            {escena.acciones.map((a, i) => (
              <li key={a} className={i < visto ? 'is-hecho' : ''} aria-hidden={i >= visto}>{a}</li>
            ))}
          </ol>
          <div className={`gh-demo__entrega${visto >= total ? ' is-lista' : ''}`} aria-hidden={visto < total}>
            <p>{escena.entrega}</p>
            {aprobado
              ? <span className="gh-demo__ok">Aprobado. Sale ahora. <button type="button" className="gh-demo__link" onClick={() => setPestana('registro')}>Ver en el registro</button></span>
              : <button type="button" className="guia-btn guia-btn--solido" onClick={aprobar} tabIndex={visto < total ? -1 : 0}>Aprobar</button>}
          </div>
        </div>
      ) : (
        <div className="gh-demo__cuerpo" role="tabpanel">
          <table className="gh-demo__tabla" aria-label="Registro de tareas (ejemplo)">
            <thead><tr><th scope="col">Cuándo</th><th scope="col">Pedido</th><th scope="col">Estado</th></tr></thead>
            <tbody>
              {filas.map(f => (
                <tr key={f.hora + f.pedido}><td>{f.hora}</td><td>{f.pedido}</td><td><span className={f.estado === 'Aprobado' ? 'is-ok' : 'is-espera'}>{f.estado}</span></td></tr>
              ))}
            </tbody>
          </table>
          <button type="button" className="gh-demo__repetir" onClick={repetir}>Ver de nuevo</button>
        </div>
      )}
    </figure>
  );
};

export default DemoAgencia;
